import React, { useEffect, useState, useRef } from "react";
import AdminSidebar from "../components/AdminSidebar";
import api, { API } from "../lib/api";
import { toast } from "sonner";
import { Upload, X, Image as ImageIcon, Info } from "lucide-react";

const SLOTS_COUNT = 4;

export default function AdminGallery() {
    const [gallery, setGallery] = useState([]);
    const [uploading, setUploading] = useState(null); // slot index
    const fileRefs = useRef([]);

    const load = async () => {
        const r = await api.get("/admin/restaurant");
        setGallery(r.data.gallery || []);
    };
    useEffect(() => { load(); }, []);

    const save = async (next) => {
        try {
            await api.put("/admin/restaurant", { gallery: next });
            setGallery(next);
        } catch { toast.error("Errore salvataggio galleria"); }
    };

    const handleFile = async (idx, file) => {
        if (!file) return;
        setUploading(idx);
        try {
            const data = new FormData();
            data.append("file", file);
            const r = await api.post("/admin/upload-photo", data, { headers: { "Content-Type": "multipart/form-data" } });
            const next = [...gallery];
            next[idx] = r.data.path;
            await save(next);
            toast.success("Foto caricata");
        } catch (err) {
            toast.error(err.response?.data?.detail || "Upload fallito");
        } finally {
            setUploading(null);
        }
    };

    const remove = async (idx) => {
        if (!window.confirm("Rimuovere questa foto?")) return;
        const next = gallery.filter((_, i) => i !== idx);
        await save(next);
        toast.success("Foto rimossa");
    };

    return (
        <div className="flex min-h-screen bg-ink" data-testid="admin-gallery-page">
            <AdminSidebar />
            <main className="flex-1 p-10">
                <div className="mb-8">
                    <div className="text-gold text-xs tracking-[0.4em] uppercase">Gestione</div>
                    <h1 className="font-serif text-5xl text-white mt-2">Galleria</h1>
                    <p className="text-gray-400 text-sm mt-2">Carica fino a 4 foto del tuo ristorante: interni, piatti, ambiente. Compariranno sulla pagina pubblica.</p>
                </div>

                <div className="mb-6 max-w-3xl bg-gold/5 border border-gold/20 rounded-sm p-4 flex items-start gap-3">
                    <Info size={16} className="text-gold mt-0.5 flex-shrink-0" strokeWidth={1.5} />
                    <div className="text-xs text-gray-300">
                        Formati: JPG, PNG, WEBP · Max 5MB per foto · Rapporto consigliato 4:3 o 16:9 · Carica almeno 3 foto per un effetto ottimale.
                    </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-4xl">
                    {Array.from({ length: SLOTS_COUNT }).map((_, idx) => {
                        const path = gallery[idx];
                        return (
                            <div key={idx} className="relative aspect-[16/10] bg-ink-surface border border-white/10 rounded-sm overflow-hidden group" data-testid={`gallery-slot-${idx}`}>
                                {path ? (
                                    <>
                                        <img src={`${API}/files/${path}`} alt={`Foto ${idx + 1}`} className="w-full h-full object-cover" />
                                        <button onClick={() => remove(idx)}
                                            className="absolute top-3 right-3 bg-black/70 text-white p-2 rounded-sm opacity-0 group-hover:opacity-100 hover:bg-red-500/80 transition-opacity"
                                            data-testid={`remove-photo-${idx}`}>
                                            <X size={14} />
                                        </button>
                                        <div className="absolute bottom-3 left-3 bg-black/70 text-gold px-3 py-1 text-xs tracking-widest uppercase rounded-sm">
                                            Foto {idx + 1}
                                        </div>
                                    </>
                                ) : (
                                    <button onClick={() => fileRefs.current[idx]?.click()}
                                        disabled={uploading === idx}
                                        data-testid={`upload-slot-${idx}`}
                                        className="w-full h-full flex flex-col items-center justify-center gap-3 text-gray-500 hover:text-gold hover:bg-white/5 transition-colors">
                                        {uploading === idx ? (
                                            <div className="w-8 h-8 border-2 border-gold border-t-transparent rounded-full animate-spin" />
                                        ) : (
                                            <>
                                                <ImageIcon size={32} strokeWidth={1} />
                                                <div className="text-sm">Foto {idx + 1}</div>
                                                <div className="text-[10px] uppercase tracking-widest flex items-center gap-1">
                                                    <Upload size={10} /> Carica
                                                </div>
                                            </>
                                        )}
                                    </button>
                                )}
                                <input ref={(el) => (fileRefs.current[idx] = el)}
                                    type="file" accept="image/jpeg,image/png,image/webp" className="hidden"
                                    onChange={(e) => handleFile(idx, e.target.files[0])}
                                    data-testid={`file-input-${idx}`} />
                            </div>
                        );
                    })}
                </div>
            </main>
        </div>
    );
}
